import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { Box, Icon, Typography } from '@material-ui/core';
import { TreeItem, TreeView } from '@material-ui/lab';
import CreateDialogDialog from '../dialogs/CreateDialogDialog';
import { useSiteContext } from '../SiteContext';
const StyledDiv = styled.div `
  width: 100%;
  height: 100%;
  .tree-item {
    white-space: nowrap;
    .MuiTreeItem-label {
      padding: 4px 0 4px 4px;
    }
  }
`;
export const SiteDialogList = ({ addState }) => {
    const [openDialog, setOpenDialog] = addState;
    const { site, plugins, siteComponents, configureComponent, getSiteComponents, setSelectedComponent } = useSiteContext();
    const dialogComponents = useMemo(() => {
        const dialogTypes = plugins
            .filter(p => { var _a; return (_a = p.categories) === null || _a === void 0 ? void 0 : _a.includes('dialog'); })
            .map(p => p.type);
        return siteComponents.filter(c => dialogTypes.includes(c.type));
    }, [plugins, siteComponents]);
    return (React.createElement(React.Fragment, null,
        dialogComponents.length === 0 ? (React.createElement(Box, { paddingX: 2 },
            React.createElement(Typography, { variant: 'body1', color: 'textSecondary' }, "No dialog components."))) : (React.createElement(TreeView, { defaultCollapseIcon: React.createElement(Icon, null, "arrow_drop_down"), defaultExpandIcon: React.createElement(Icon, null, "arrow_right"), selected: (configureComponent === null || configureComponent === void 0 ? void 0 : configureComponent.id) || '' }, dialogComponents.map(component => (React.createElement(SiteDialogItem, { component: component, key: component.id, onClick: () => {
                setSelectedComponent(component);
            } }))))),
        openDialog && (React.createElement(CreateDialogDialog, { open: openDialog, onCancel: () => setOpenDialog(false), onCreated: () => {
                (site === null || site === void 0 ? void 0 : site.id) && getSiteComponents(site.id);
                setOpenDialog(false);
            } }))));
};
export default SiteDialogList;
export const SiteDialogItem = (props) => {
    const { onClick } = props;
    const { subscribe, unsubscribe } = useSiteContext();
    const [component, setComponent] = useState(props.component);
    // Make a local reference to the component state
    const componentRef = useRef(component);
    // Subscribe to any component changes coming from the component editor
    useEffect(() => {
        const handleSubscribe = (component) => {
            componentRef.current = component;
            setComponent(component);
        };
        const component = componentRef.current;
        subscribe(component, handleSubscribe);
        return () => unsubscribe(component, handleSubscribe);
    }, [subscribe, unsubscribe]);
    return (React.createElement(TreeItem, Object.assign({ className: 'tree-item', nodeId: component.id, label: component.name, onLabelClick: event => {
            event.preventDefault();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        } }, props)));
};
//# sourceMappingURL=SiteDialogList.js.map